export class AppConfig {
    static maximumUserAge = 99;
    static minimumAgeRequired = 18;
}